<template>
  <footer class="footer">
    <div class="footer-content">
      <div class="footer-top">
        <div class="footer-logo">
          <div class="logo-wrapper">
            <img src="@/assets/images/logo.png" alt="MP3 Converter Logo" class="footer-logo-img">
            <div class="logo-text-wrapper">
              <span class="logo-text">MP3 Converter</span>
              <p class="logo-subtitle">Audio Trimmer</p>
            </div>
          </div>
          <p class="footer-description">Video to MP3 conversion, precise trimming, and ringtone-ready audio for iPhone.</p>
        </div>

        <div class="footer-links">
          <div class="links-group">
            <h4>Quick Links</h4>
            <div class="links-list">
              <router-link to="/" class="footer-link">
                <i class="fas fa-home"></i>
                <span>Home</span>
              </router-link>
              <a href="#features" class="footer-link">
                <i class="fas fa-star"></i>
                <span>Features</span>
              </a>
              <a href="#download" class="footer-link">
                <i class="fas fa-download"></i>
                <span>Download</span>
              </a>
            </div>
          </div>

          <div class="links-group">
            <h4>Resources</h4>
            <div class="links-list">
              <router-link to="/help" class="footer-link">
                <i class="fas fa-question-circle"></i>
                <span>Help Center</span>
              </router-link>
              <router-link to="/privacy" class="footer-link">
                <i class="fas fa-shield-alt"></i>
                <span>Privacy Policy</span>
              </router-link>
              <router-link to="/terms" class="footer-link">
                <i class="fas fa-file-contract"></i>
                <span>Terms of Service</span>
              </router-link>
            </div>
          </div>

          <div class="links-group">
            <h4>Contact Us</h4>
            <div class="links-list">
              <a href="mailto:morimotos@163.com" class="footer-link">
                <i class="fas fa-envelope"></i>
                <span>morimotos@163.com</span>
              </a>
              <div class="footer-link">
                <i class="fas fa-headset"></i>
                <span>24/7 Support</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="divider"></div>

      <div class="footer-bottom">
        <div class="legal-links">
          <span>No sign-in required</span>
          <span class="dot">•</span>
          <span>iOS app available now</span>
          <span class="dot">•</span>
          <span>Android coming soon</span>
        </div>
        <div class="copyright">
          <span>© 2024 MP3 Converter - Audio Trimmer. All rights reserved.</span>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'AppFooter'
}
</script>

<style scoped>
.footer {
  padding: 4.5rem 5% 2.5rem;
  position: relative;
  overflow: hidden;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  background:
    linear-gradient(180deg, rgba(255, 255, 255, 0.025), rgba(255, 255, 255, 0.01)),
    #0a0a0a;
}

.footer-content {
  max-width: 1200px;
  margin: 0 auto;
}

.footer-top {
  display: grid;
  grid-template-columns: minmax(260px, 0.9fr) minmax(0, 1.4fr);
  align-items: flex-start;
  gap: 4rem;
  margin-bottom: 2.5rem;
}

.footer-logo {
  max-width: 420px;
}

.logo-wrapper {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1.4rem;
}

.logo-text-wrapper {
  display: flex;
  flex-direction: column;
}

.footer-logo-img {
  height: 40px;
  width: auto;
}

.logo-text {
  font-size: 1.45rem;
  font-weight: 700;
  background: var(--primary-gradient);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.logo-subtitle {
  font-size: 0.9rem;
  color: var(--text-secondary);
  margin-top: 0.25rem;
}

.footer-description {
  color: var(--text-secondary);
  font-size: 1rem;
  line-height: 1.6;
}

.footer-links {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 2rem;
}

.links-group h4 {
  color: var(--text-primary);
  font-size: 0.9rem;
  font-weight: 600;
  margin-bottom: 1rem;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.links-list {
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
}

.footer-link {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  color: var(--text-secondary);
  text-decoration: none;
  transition: all 0.3s ease;
  min-height: 36px;
  padding: 0.35rem 0;
  border-radius: 8px;
}

.footer-link i {
  width: 1rem;
  font-size: 0.95rem;
  color: #2ac9ad;
  transition: transform 0.3s ease;
}

.footer-link:hover {
  color: var(--text-primary);
}

.footer-link:hover i {
  transform: translateX(2px);
}

.divider {
  height: 1px;
  background: rgba(255, 255, 255, 0.08);
  margin: 2.25rem 0 1.5rem;
}

.footer-bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 1rem;
}

.legal-links {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.65rem;
  color: var(--text-secondary);
  font-size: 0.9rem;
}

.dot {
  display: inline-block;
  color: rgba(255, 255, 255, 0.28);
}

.copyright {
  color: var(--text-secondary);
  font-size: 0.9rem;
  text-align: center;
  line-height: 1.5;
}

@media (max-width: 1024px) {
  .footer-top {
    grid-template-columns: 1fr;
    gap: 3rem;
  }
}

@media (max-width: 768px) {
  .footer {
    padding: 3.5rem 5% 2rem;
  }

  .footer-links {
    grid-template-columns: 1fr;
    gap: 2rem;
  }

  .footer-bottom {
    flex-direction: column;
    gap: 1.5rem;
  }

  .legal-links {
    flex-wrap: wrap;
    justify-content: center;
    gap: 0.55rem;
    text-align: center;
  }

  .dot {
    display: inline-block;
  }
}
</style> 
